module.exports = __webpack_public_path__ + "static/img/4.2919305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news17/4.png
// module id = B1kw
// module chunks = 1